import trustpilotSrc from "./trustpilot.png";
import trustpilotAlternateSrc from "./trustpilot_alternate.png";

export const TrustBannerImages = {
  trustpilot: {
    src: trustpilotSrc,
    altText:
      "Simply Business is rated 4 out of 5 stars with over 5,500 reviews on Trustpilot.",
  },
  trustpilot_alternate: {
    src: trustpilotAlternateSrc,
    altText:
      "Simply Business is rated 4.2 out of 5 stars with over 6,678 reviews on Trustpilot.",
  },
};
